/**
 * API通信ユーティリティ
 * VITE_API_BASE_URL が設定されていればそれを使う
 * なければ http://localhost:3001 にフォールバック
 */
// VITE_API_BASE_URL は "/api" サフィックスつきで設定されているため除去する
const _raw = (import.meta.env["VITE_API_BASE_URL"] as string | undefined) ?? "http://localhost:3001";
const BASE_URL = _raw.endsWith("/api") ? _raw.slice(0, -4) : _raw;
export const API_ORIGIN = BASE_URL;

import { getAccessToken, silentRefresh, getWebCompanySubdomain } from "../services/api";

function getToken(): string | null {
  return getAccessToken();
}

async function request<T>(
  method: string,
  path: string,
  body?: unknown,
  auth = true
): Promise<T> {
  const headers: Record<string, string> = { "Content-Type": "application/json" };
  if (auth) {
    const token = getToken();
    if (token) headers["Authorization"] = `Bearer ${token}`;
    const sub = getWebCompanySubdomain();
    if (sub) headers["X-Company-Subdomain"] = sub;
  }

  const res = await fetch(`${BASE_URL}${path}`, {
    method,
    headers,
    credentials: "include",
    body: body !== undefined ? JSON.stringify(body) : undefined,
  });

  if (res.status === 401 && auth) {
    const refreshed = await silentRefresh();
    if (refreshed) {
      const newToken = getAccessToken();
      if (newToken) headers["Authorization"] = `Bearer ${newToken}`;
      const retryRes = await fetch(`${BASE_URL}${path}`, { method, headers, credentials: "include", body: body !== undefined ? JSON.stringify(body) : undefined });
      if (!retryRes.ok) { const err = await retryRes.json().catch(() => ({ error: { message: retryRes.statusText } })); throw new Error(err?.error?.message ?? `HTTP ${retryRes.status}`); }
      return retryRes.json() as Promise<T>;
    }
    window.location.replace("/login");
    throw new Error("認証が必要です。");
  }

  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: { message: res.statusText } }));
    throw new Error(err?.error?.message ?? `HTTP ${res.status}`);
  }

  return res.json() as Promise<T>;
}

export const api = {
  get:    <T>(path: string)                    => request<T>("GET",    path),
  post:   <T>(path: string, body: unknown)     => request<T>("POST",   path, body),
  put:    <T>(path: string, body: unknown)     => request<T>("PUT",    path, body),
  delete: <T>(path: string)                    => request<T>("DELETE", path),
  postNoAuth: <T>(path: string, body: unknown) => request<T>("POST",   path, body, false),
};
